import React from 'react';
import classNames from 'classnames';
 const DividerLine = ({className})=>{
    const dividerClass = classNames(
        'w-full','bg-[#DB3222]','pb-1','pointer-events-none',className
    );
    return <div className={dividerClass} />
}
export default DividerLine